export enum ComparePageObjectModel {
  CompareSidebar = 'compare-sidebar',
  ComparisonViewer = '3D Model Comparison Viewer',
  ErrorTitle = 'error-title',
  ErrorMessage = 'error-message',
  LoadingIndicator = 'loading-indicator',
  ZeroStateContainer = 'zero-state-container',
}
